import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.JensenPhoneNumberPools = routerStyxie({ actions: ['index', 'new', 'edit']})
